import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chart-3, statistics, graph, signal"><path d="M3.75 13.5273V20.2496H7.58V13.5273H3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.08 9.08398V20.2507H13.91V9.08398H10.08Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.42 3.75V20.25H20.25V3.75H16.42Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChart3;
